import React, { useState } from 'react';
import { Printer, Edit2, RefreshCw, Trash2 } from 'lucide-react';
import { PrintTicketButton } from '../../components/PrintTicketButton';

const PrintOption = ({ icon: Icon, title, description, onClick }) => (
  <button 
    onClick={onClick}
    className="w-full px-4 py-3 text-left flex items-center text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border-b dark:border-gray-700"
  >
    <Icon className="w-4 h-4 mr-2" />
    <div>
      <div className="font-medium">{title}</div>
      <div className="text-xs text-gray-500 dark:text-gray-400">{description}</div>
    </div>
  </button>
);

const PrintOptions = ({ status, onClose, onEdit, onDelete, sale }) => {
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  
  const handlePrintOption = (type) => {
    setSelectedTicketType(type);
    onClose();
  };
  
  // Renderizar el botón de impresión si se ha seleccionado un tipo de ticket
  if (selectedTicketType) {
    // Usar setTimeout para permitir que el menú se cierre antes de mostrar el botón
    setTimeout(() => {
      const printButton = document.getElementById(`print-ticket-${selectedTicketType}`);
      if (printButton) {
        printButton.click();
        setSelectedTicketType(null);
      }
    }, 100);
  }
  
  return (
    <>
      <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg border dark:border-gray-700 py-1">
        {/* Título */}
        <div className="px-4 py-2 text-sm font-medium text-gray-900 dark:text-white border-b dark:border-gray-700">
          Opciones de impresión
        </div>

        {/* Botones de impresión visibles */}
        <div className="px-4 py-2 border-b dark:border-gray-700">
          <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-2">Imprimir tickets</h3>
          <div className="flex flex-col gap-2">
            <PrintTicketButton 
              sale={sale} 
              type="delivery" 
              label="Para cliente" 
              className="w-full text-sm py-1.5"
            />
            <PrintTicketButton 
              sale={sale} 
              type="fulfillment" 
              label="Para despacho" 
              className="w-full text-sm py-1.5"
            />
            <PrintTicketButton 
              sale={sale} 
              type="backup" 
              label="Para negocio" 
              className="w-full text-sm py-1.5"
            />
          </div>
        </div>

        {/* Separador */}
        <div className="my-1 border-b dark:border-gray-700"></div>

        {/* Opciones de impresión (mantenemos las opciones originales) */}
        <PrintOption
          icon={Printer}
          title="Para el cliente"
          description="Incluye precios y detalle completo"
          onClick={() => handlePrintOption('delivery')}
        />
        <PrintOption
          icon={Printer}
          title="Para despacho"
          description="Solo productos y datos de entrega"
          onClick={() => handlePrintOption('fulfillment')}
        />
        <PrintOption
          icon={Printer}
          title="Para el negocio"
          description="Copia con todos los detalles"
          onClick={() => handlePrintOption('backup')}
        />

        {/* Separador */}
        <div className="my-1 border-b dark:border-gray-700"></div>

        {/* Acciones adicionales según estado */}
        {status === 'pending' && (
          <button 
            onClick={onEdit}
            className="w-full px-4 py-3 text-left flex items-center text-blue-600 dark:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 border-b dark:border-gray-700"
          >
            <Edit2 className="w-4 h-4 mr-2" />
            <div className="font-medium">Editar venta</div>
          </button>
        )}

        <button className="w-full px-4 py-3 text-left flex items-center text-orange-600 dark:text-orange-400 hover:bg-gray-50 dark:hover:bg-gray-700 border-b dark:border-gray-700">
          <RefreshCw className="w-4 h-4 mr-2" />
          <div className="font-medium">Registrar devolución</div>
        </button>

        {/* Botón de cancelar venta (antes era eliminar) */}
        {(status === 'pending' || status === 'confirmed' || status === 'paid') && (
          <button 
            onClick={onDelete}
            className="w-full px-4 py-3 text-left flex items-center text-red-600 dark:text-red-400 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            <div className="font-medium">Cancelar venta</div>
          </button>
        )}
      </div>
      
      {/* Botones de impresión ocultos */}
      <div className="hidden">
        <PrintTicketButton 
          id={`print-ticket-delivery`}
          sale={sale} 
          type="delivery" 
        />
        <PrintTicketButton 
          id={`print-ticket-fulfillment`}
          sale={sale} 
          type="fulfillment" 
        />
        <PrintTicketButton 
          id={`print-ticket-backup`}
          sale={sale} 
          type="backup" 
        />
      </div>
    </>
  );
}

export default PrintOptions; 